// dependencies
import React from "react";
import PropTypes from "prop-types";
import { Map, List } from "immutable";
import { connect } from "react-redux";
import { getMatchedRouteKeyValue } from "yarrr";

// components
import Avatar from "Components/Avatar";
import Employee from "./components/Employee";
import TextInput from "Components/Inputs/Text";
import Navigation from "./components/Navigation";
import Breadcrumbs from "./components/Breadcrumbs";
import UpcomingNotifications from "./components/UpcomingNotifications";

// selectors
import { getUserSearchResults } from "Selectors/users";
import { getCurrentQuery, getSelectedUser } from "./selectors";

// actions
import { init, updateQuery, selectUser } from "./actions";

// css
import css from "./BreadcrumbsPage";

class BreadcrumbsPage extends React.PureComponent {
	static propTypes = {
		updateQuery: PropTypes.func.isRequired,
		init: PropTypes.func.isRequired,
		selectUser: PropTypes.func.isRequired,
		selectedUser: PropTypes.instanceOf(Map),
		currentQuery: PropTypes.string.isRequired,
		environment: PropTypes.string.isRequired,
		activeView: PropTypes.string.isRequired,
		currentResults: PropTypes.instanceOf(List).isRequired,
	};

	static defaultProps = {
		selectedUser: null,
	};

	componentDidMount = () => {
		this.props.init();
	};

	componentDidUpdate = (prevProps) => {
		if (prevProps.environment !== this.props.environment) {
			this.props.init();
		}
	};

	handleSearchChange = (query) => {
		this.props.updateQuery(query);
	};

	handleSelectUser = (userID) => {
		this.props.selectUser(userID);
	};

	render = () => {
		const { currentQuery, currentResults, selectedUser, activeView } = this.props;
		const selectedUserID = selectedUser ? selectedUser.get("id", null) : null;

		return (
			<div className={css.BreadcrumbsContainer}>
				<div className={css.searchContainer}>
					<div className={css.searchboxWrapper}>
						<div>
							<div className={css.label}>Search Users</div>
							<TextInput value={currentQuery} onChange={this.handleSearchChange} />
						</div>
					</div>

					<div className={css.results}>
						{currentResults.map((result) => {
							const userID = result.get("id");
							const isActive = userID === selectedUserID;

							return (
								<div
									onClick={() => this.handleSelectUser(userID)}
									key={userID}
									className={`${css.userItem} ${isActive ? css.isSelected : ""}`}
								>
									<div className={css.innerUserItem}>
										<Avatar className={css.userAvatar} size={30} userID={userID} />
										<div className={css.userName}>{result.get("name")}</div>
										<div className={css.companyName}>{result.get("companyName")}</div>
									</div>
								</div>
							);
						})}
					</div>
				</div>

				<div className={css.breadcrumbs}>
					<div className={css.employeeContent}>
						<div className={css.employeeWrapper}>
							<div>{selectedUser ? <Employee /> : null}</div>

							<div>
								<Navigation />

								<div className={css.viewWrapper}>
									{selectedUser && activeView === "breadcrumbs" ? <Breadcrumbs /> : null}
									{selectedUser && activeView === "asap-notifications" ? (
										<UpcomingNotifications type="asap" />
									) : null}
									{selectedUser && activeView === "daily-notifications" ? (
										<UpcomingNotifications type="deferred" />
									) : null}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	};
}

const mapStateToProps = (state) => {
	const currentQuery = getCurrentQuery(state);
	const activeView = getMatchedRouteKeyValue(state, "view");

	return {
		currentQuery,
		selectedUser: getSelectedUser(state),
		activeView: activeView || "breadcrumbs",
		currentResults: getUserSearchResults(state, currentQuery),
	};
};

const mapDispatchToProps = (dispatch) => ({
	init: (query) => dispatch(init(query)),
	updateQuery: (query) => dispatch(updateQuery(query)),
	selectUser: (userID) => dispatch(selectUser(userID)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BreadcrumbsPage);
